module.exports = __webpack_public_path__ + "static/media/call-expert-green.a1035e3c.svg";